import React from 'react';
import { TableRow, Theme, makeStyles, TableRowProps } from '@material-ui/core';

interface PasslyTableRowProps extends TableRowProps {
    clickable?: boolean;
}

export function PasslyTableRow(props: PasslyTableRowProps) {
    const passlyTableRowStyles = makeStyles((theme: Theme) => {
        return {
            root: {
                '&:nth-of-type(even)': {
                    backgroundColor: theme.tablerow.secondary
                },
                '&:nth-of-type(odd)': {
                    backgroundColor: theme.tablerow.primary
                },
                '&:hover': {
                    backgroundColor: theme.palette.action.hover,
                    cursor: props.clickable ? 'pointer' : 'default'
                },
                '&:hover .tablev2__rowIconHoverStyle': {
                    color: theme.palette.primary.main
                },
                '.tablev2__rowIconHoverStyle': {
                    color: theme.palette.action.disabled
                },
                '&.Mui-selected': {
                    '&:nth-of-type(even)': {
                        backgroundColor: theme.tablerow.selectedSecondary
                    },
                    '&:nth-of-type(odd)': {
                        backgroundColor: theme.palette.secondary.main
                    }
                },
            }
        }
    });

    const classes = passlyTableRowStyles();

    return (
        <TableRow classes={{ root: classes.root }} {...props} />
    );
}

